import { inject, observer } from 'mobx-react'
import React from 'react'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'

const MySalaryListPagination = props => {
  const { salaryStore } = props

  const handleChangePagination = (page, size) => {
    salaryStore.setQueryParams('filterPageMySalary', page - 1)
    salaryStore.setQueryParams('filterSizeMySalary', size)
  }
  return (
    <>
      <AppTablePagination
        current={salaryStore.filterPageMySalary + 1}
        pageSize={salaryStore.filterSizeMySalary}
        total={salaryStore.mySalaryTotal}
        onChange={handleChangePagination}
      />
    </>
  )
}

MySalaryListPagination.propTypes = {}
export default inject('salaryStore')(observer(MySalaryListPagination))
